var _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNdeIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    enableBackground: "new 0 0 35 35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "palette",
    display: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "artboards_-_bkgds"
  }), /*#__PURE__*/React.createElement("g", {
    id: "page_contents"
  }), /*#__PURE__*/React.createElement("g", {
    id: "header__x2F__nav"
  }), /*#__PURE__*/React.createElement("g", {
    id: "overlay"
  }), /*#__PURE__*/React.createElement("g", {
    id: "map"
  }), /*#__PURE__*/React.createElement("g", {
    id: "extras",
    display: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "annotation"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 17.407,
    cy: 17.541,
    r: 15.706
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2231A",
    d: "M17.5,0C7.836-0.001,0,7.833,0,17.5C0,27.164,7.837,35,17.5,35C27.167,35,35,27.165,35,17.5 C35,7.833,27.166,0,17.5,0z M22.392,25.677l-4.855-4.855l-4.994,4.995l-3.831-3.831l4.995-4.994L8.85,12.135l3.415-3.415 l4.856,4.856l4.994-4.995l3.831,3.831l-4.995,4.995l4.856,4.855L22.392,25.677z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdeIconDelete);
export default __webpack_public_path__ + "static/media/nde-icon-delete.4045e9d1.svg";
export { ForwardRef as ReactComponent };